const messagePrefix = 'caseFeeTypes'

export const getMortgageFeeTypeLabel = (feeType: FeeType) => {
  switch (feeType) {
    case 'PREADVICE_FIXED':
      return `${messagePrefix}.preMortgageAdvice`
    case 'PRERECOMMENDATION_FIXED':
      return `${messagePrefix}.preMortgageRecommendation`
    case 'PRERECOMMENDATION_PERCENT':
      return `${messagePrefix}.preMortgageRecommendationPercent`
    case 'PREAPPLICATION_FIXED':
      return `${messagePrefix}.preMortgageApplication`
    case 'PREAPPLICATION_PERCENT':
      return `${messagePrefix}.preMortgageApplicationPercent`
    case 'OFFER_FIXED':
      return `${messagePrefix}.offer`
    case 'OFFER_PERCENT':
      return `${messagePrefix}.offerPercent`
    case 'LEGAL_COMPLETION_FIXED':
      return `${messagePrefix}.legalCompletion`
    case 'LEGAL_COMPLETION_PERCENT':
      return `${messagePrefix}.legalCompletionPercent`
    case 'LEGAL_EXCHANGE_FIXED':
      return `${messagePrefix}.legalExchangeFixed`
    case 'LEGAL_EXCHANGE_PERCENT':
      return `${messagePrefix}.legalExchangePercent`
    default:
      return `${messagePrefix}.invalidFeeType`
  }
}
